import { Component, OnInit } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, Router } from '@angular/router'
import { UnespCoreMessageService } from '@unesp/core'
import { StorageFolder } from 'src/app/enums/storage-folder'
import { DepartamentoAnalisarPlano } from 'src/app/models/departamento-analisar-plano'
import { DepartamentoAnalisarPlanoForm } from 'src/app/models/departamento-analisar-plano-form'
import { DepartamentoService } from 'src/app/services/departamento-service'
import { PdfViewerComponent } from '../../comum/pdf-viewer/pdf-viewer.component'
import { MatSelectChange } from '@angular/material/select'

@Component({
  selector: 'app-departamento-analisar-plano',
  templateUrl: './departamento-analisar-plano.component.html',
  styleUrls: ['./departamento-analisar-plano.component.css'],
  standalone: false
})
export class DepartamentoAnalisarPlanoComponent implements OnInit {
  id: number = 0
  inscricao?: DepartamentoAnalisarPlano

  form = new FormGroup({
    aprovado: new FormControl('', Validators.required),
    motivo: new FormControl(''),
  })

  constructor(
    private route: ActivatedRoute,
    private departamentoService: DepartamentoService,
    private unespCoreMessageService: UnespCoreMessageService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id']
      this.departamentoService.analisarPlano(this.id).subscribe(data => {
        this.inscricao = data
        this.form.controls['motivo'].setValue(data.motivo)
        if (data.aprovado === 'sim' || data.aprovado === 'rep') {
          this.form.controls['aprovado'].setValue(data.aprovado)
        }
      })
    })
  }

  applyTouchedToInvalidFields() {
    for (const name in this.form.controls) {
      if (this.form.get(name)?.invalid) {
        this.form.get(name)?.markAsTouched()
      }
    }
  }

  gravar(): void {
    this.applyTouchedToInvalidFields()
    if (!this.form.valid) {
      this.unespCoreMessageService.showMessageError('Erro ao preencher os dados do formulário')
      return
    }
    let formulario = <DepartamentoAnalisarPlanoForm>this.form.value
    if (formulario.aprovado === 'sim') {
      formulario.motivo = ''
    }
    this.departamentoService.registrarAnalisePlano(this.id, formulario).subscribe(data => {
      if (data.status === 'ok') {
        this.unespCoreMessageService.showMessageSuccess(`Plano #${this.id} registrado com sucesso`)
        this.router.navigate(['/departamento/aprovar-plano'])
      } else {
        this.unespCoreMessageService.showMessageError(data.message)
      }
    })
  }

  download(row?: DepartamentoAnalisarPlano): void {
    if (row) {
      this.departamentoService.download(StorageFolder.plano_atividade, row.idInscricao).subscribe(data => {
        let blob = new Blob([data], {
          type: 'application/pdf',
        })
        let url = window.URL.createObjectURL(blob)
        this.dialog.open(PdfViewerComponent, {
          data: {
            titulo: row.nome,
            url: url,
          },
          width: '80%',
          height: '90%',
        })
      })
    }
  }

  alteraSituacao(selection: MatSelectChange): void {
    if (selection.value === 'rep' || selection.value === 'can') {
      this.form.get('motivo')?.setValidators([Validators.required])
    } else {
      this.form.get('motivo')?.clearValidators()
    }
    this.form.get('motivo')?.updateValueAndValidity()
  }
}
